<template>
  <el-row>
    <el-col :span="24">
      <el-card>
        <div slot="header" class="flex justify-between">
          <span>{{ $t('addPrivilegeView.title') }}</span>
        </div>
        <el-form :model="addPrivilegeViewInfo" label-width="120px">
          <el-form-item :label="$t('addPrivilegeView.privilegeName')" required>
            <el-input
              v-model="addPrivilegeViewInfo.name"
              :placeholder="$t('addPrivilegeView.privilegeNamePlaceholder')"
              readonly
              style="width: 100%">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('addPrivilegeView.resourcePath')" required>
            <el-input
              v-model="addPrivilegeViewInfo.resource"
              :placeholder="$t('addPrivilegeView.resourcePathPlaceholder')"
              style="width: 100%">
            </el-input>
          </el-form-item>
          <el-form-item :label="$t('addPrivilegeView.storeType')" required>
            <el-select
              v-model="addPrivilegeViewInfo.domain"
              style="width: 100%"
              :placeholder="$t('addPrivilegeView.storeTypePlaceholder')">
              <el-option
                :label="$t('addPrivilegeView.operationTeam')"
                value="800900000001">
              </el-option>
              <el-option
                :label="$t('addPrivilegeView.merchant')"
                value="800900000005">
              </el-option>
              <el-option
                :label="$t('addPrivilegeView.devTeam')"
                value="800900000000">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('addPrivilegeView.description')">
            <el-input
              type="textarea"
              :rows="3"
              :placeholder="$t('addPrivilegeView.descriptionPlaceholder')"
              v-model="addPrivilegeViewInfo.description"
              readonly
              style="width: 100%">
            </el-input>
          </el-form-item>
        </el-form>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'AddPrivilegeView',
  props: {
    callBackListener: String,
    callBackFunction: String
  },
  data() {
    return {
      addPrivilegeViewInfo: {
        flowComponent: 'addPrivilegeView',
        name: '',
        resource: '',
        domain: '',
        description: ''
      }
    }
  },
  watch: {
    addPrivilegeViewInfo: {
      deep: true,
      handler(newVal) {
        console.log(newVal)
        this.saveAddPrivilegeInfo()
      }
    }
  },
  methods: {
    saveAddPrivilegeInfo() {
      if (this.validateForm()) {
        this.$emit(this.callBackFunction, this.addPrivilegeViewInfo)
      }
    },
    validateForm() {
      if (!this.addPrivilegeViewInfo.name) {
        this.$message.warning(this.$t('addPrivilegeView.privilegeNameRequired'))
        return false
      }
      if (!this.addPrivilegeViewInfo.resource) {
        this.$message.warning(this.$t('addPrivilegeView.resourcePathRequired'))
        return false
      }
      if (!this.addPrivilegeViewInfo.domain) {
        this.$message.warning(this.$t('addPrivilegeView.storeTypeRequired'))
        return false
      }
      return true
    },
    onIndex(index) {
      console.log(index)
      this.addPrivilegeViewInfo.index = index
    }
  },
  created() {
    this.$on('syncData', (data) => {
      Object.assign(this.addPrivilegeViewInfo, data)
      if (data.url && data.url.indexOf("/flow") === 0 && data.url.length > 5) {
        this.addPrivilegeViewInfo.resource = data.url.substring(5)
      } else if (data.url) {
        this.addPrivilegeViewInfo.resource = data.url
      }
    })
  }
}
</script>

<style scoped>
.el-row, .el-col {
  width: 100%;
}
</style>